import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { ContactPickerPane } from 'owa-contact-picker';
import showHideContactPicker from 'owa-readwrite-recipient-well/lib/actions/showHideContactPicker';
import getRecipientString from 'owa-readwrite-recipient-well/lib/utils/getRecipientString';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import * as React from 'react';
var styles = require('./RecipientWellLabelWithContactPicker.scss');
var RecipientWellLabelWithContactPicker = /** @class */ (function (_super) {
    tslib_1.__extends(RecipientWellLabelWithContactPicker, _super);
    function RecipientWellLabelWithContactPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setContactPickerState = function (recipientWell, isVisible) { return function () {
            showHideContactPicker(recipientWell, isVisible);
        }; };
        _this.bindContactPickerRef = function (ref) {
            if (ref != null) {
                _this.contactPickerButton = ref;
            }
        };
        _this.getContactPickerButton = function () {
            return _this.contactPickerButton;
        };
        return _this;
    }
    RecipientWellLabelWithContactPicker.prototype.render = function () {
        var _a = this.props, recipientWell = _a.recipientWell, recipientType = _a.recipientType, addRecipient = _a.addRecipient;
        var wellLabel = recipientType != RecipientType.None ? (React.createElement("div", { tabIndex: 0, onClick: this.setContactPickerState(recipientWell, !recipientWell.shouldShowContactPicker), className: styles.label }, getRecipientString(recipientType))) : null;
        return (React.createElement("div", { ref: this.bindContactPickerRef },
            wellLabel,
            recipientWell.shouldShowContactPicker && (React.createElement(ContactPickerPane, { viewState: recipientWell.contactPicker, findControlGetter: this.getContactPickerButton, dismissContactPickerAction: this.setContactPickerState(recipientWell, false /* isVisible */), addRecipientAction: addRecipient }))));
    };
    RecipientWellLabelWithContactPicker = tslib_1.__decorate([
        observer
    ], RecipientWellLabelWithContactPicker);
    return RecipientWellLabelWithContactPicker;
}(React.Component));
export default RecipientWellLabelWithContactPicker;
//# sourceMappingURL=RecipientWellLabelWithContactPicker.js.map